import { Injectable } from '@angular/core';
import { CuponPagoTarjeta, PagoElectronicoDto } from '@shared/models/facturacion';
import { DescuentoPagoElectronico } from './models/facturacion/DescuentoPagoElectronico';
import { PagoContado } from './models/facturacion/PagoContado';

@Injectable({
  providedIn: 'root'
})
export class FacturaService {

  constructor() { }

  calcularTotalCupones(cupones: CuponPagoTarjeta[]): number {
    if (!cupones || cupones.length === 0) {
      return 0;
    }

    return cupones?.reduce((total: number, cupon: CuponPagoTarjeta) => total + cupon.importe, 0);
  }
  
  calcularTotalCuponesCierre(pago: PagoContado[]): number {
    let total = 0;
    pago.forEach(p => {
      total += p.totalCupones;
    })
    return total;
  }

  calcularTotalPagosElectronicos(pagosElectronicos: PagoElectronicoDto[]): number {
    if (!pagosElectronicos || pagosElectronicos.length === 0) {
      return 0;
    }

    return pagosElectronicos.reduce((total: number, pago: PagoElectronicoDto) => total + pago.importe, 0);
  }

  calcularTotalDescuentosPagosElectronicos(pagosElectronicos: PagoElectronicoDto[]): number {
    if (!pagosElectronicos || pagosElectronicos.length === 0) {
      return 0;
    }

    return pagosElectronicos.reduce((total, pago) => {
      const totalDescuento = pago.discounts?.reduce((acum: number, discount: DescuentoPagoElectronico) => acum + discount.amount, 0);
      return total + totalDescuento;
    }, 0)
  }
}
